import Button from 'Components/Atoms/Button/Button';
import Container from 'Components/Atoms/Container/Container';
import Title from 'Components/Atoms/Title/Title';
import ButtonGroup from 'Components/Molecules/ButtonGroup/ButtonGroup';
import Modal from 'Components/Molecules/Modals/Modal/Modal';
import ModalFooter from 'Components/Molecules/Modals/ModalFooter/ModalFooter';
import ModalHeader from 'Components/Molecules/Modals/ModalHeader/ModalHeader';
import { useEffect, useState } from 'react';
import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import { connect } from 'react-redux';
import { prepareDualListBox } from 'Services/helpers';
import { StoreState } from 'Store/Reducers';
import { patchEntityTypeById } from 'Store/Settings/EntityTypes/Actions';
import { getEntityTypeById, isEntityTypesPatching } from 'Store/Settings/EntityTypes/Selector';
import { getActiveFieldsByEntityIdAsArray } from 'Store/Settings/Fields/Selectors';

const LayoutSidebar = ({
    onClose, type_id,
    fields,

    entityType,

    isPatching,

    ...props
}: LayoutSidebarProps) => {
    const [state, setState] = useState({
        isSaving: false
    })
    const [data, setData] = useState(entityType?.sidebar_field_ids ?? []);

    const handleSave = () => {
        setState((state) => ({
            ...state,
            isSaving: true
        }));
        console.log(data);
        props.patchEntityTypeById(type_id, {
            sidebar_field_ids: data
        });
    }

    useEffect(() => {
        if (!isPatching && state.isSaving) onClose();
    }, [isPatching]);

    return <Modal>
        <ModalHeader>
            <Title size='large' weight='bold'>
                Sidebar aanpassen
            </Title>
        </ModalHeader>
        <Container padding='vertical'>
            <DualListBox
                className='duallistbox'
                preserveSelectOrder
                showOrderButtons
                options={prepareDualListBox(fields)}
                selected={data}
                onChange={(value: any) => setData(value)}
            />
        </Container>
        <ModalFooter>
            <ButtonGroup>
                { !isPatching &&
                    <Button
                        variant="transparent"
                        onClick={() => onClose()}
                    >
                        Annuleren
                    </Button>
                }
                <Button
                    color="primary"
                    variant="solid"
                    isLoading={isPatching}
                    onClick={handleSave}
                >
                    Aanpassen
                </Button>
            </ButtonGroup>
        </ModalFooter>
    </Modal>;
}

interface Props {
    onClose: any
    type_id: any
    entity_id: any
}

const mapState = (state: StoreState, props: Props) => ({
    entityType: getEntityTypeById(state, props.type_id),

    fields: getActiveFieldsByEntityIdAsArray(state, props.entity_id),
    isPatching: isEntityTypesPatching(state)
});

const mapDispatch = {
    patchEntityTypeById
}

type LayoutSidebarProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(LayoutSidebar);